import { render } from "./PointHistoryGiftInfo.vue?vue&type=template&id=46b2056b&ts=true"
import script from "./PointHistoryGiftInfo.vue?vue&type=script&lang=ts"
export * from "./PointHistoryGiftInfo.vue?vue&type=script&lang=ts"

import "./PointHistoryGiftInfo.vue?vue&type=style&index=0&id=46b2056b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__